const MAX_PHOTO_BYTES = 25 * 1024 * 1024;
const MAX_SHARE_BYTES = 5 * 1024 * 1024;
const SHARE_FOLDER = 'kelimo-share';
const SHARE_FILE = /^result-(\d{13})-[a-f0-9]{16}\.png$/;
function nativeMedia(win = typeof window !== 'undefined' ? window : null) {
  if (!win?.Capacitor?.isNativePlatform?.()) return null;
  if (!win.KelimoNative?.media) throw new Error('Cihazın fotoğraf ve paylaşım bileşenleri hazırlanamadı.');
  return win.KelimoNative.media;
}
function cancelledMedia(error) {
  return error?.name === 'AbortError' || ['OS-PLUG-CAMR-0006', 'OS-PLUG-CAMR-0013', 'OS-PLUG-CAMR-0020'].includes(error?.code) || /cancelled|canceled|user cancel/i.test(error?.message || '');
}
async function pickNativePhoto(media = nativeMedia(), fetcher = fetch, FileClass = File) {
  if (!media) return null;
  const picked = await media.camera.chooseFromGallery({ mediaType: 0, allowMultipleSelection: false, includeMetadata: false });
  if (!picked.results?.length) return null;
  const photo = picked.results[0];
  if (photo.type !== 0 || typeof photo.webPath !== 'string') throw new Error('Bir fotoğraf seçmelisin.');
  // Only URLs returned by the local native picker are read. Never download an arbitrary remote image.
  const url = new URL(photo.webPath);
  if (!((url.protocol === 'https:' && url.hostname === 'localhost') || (url.protocol === 'capacitor:' && url.hostname === 'localhost')) || !/^\/_capacitor_(file|content)_\//.test(url.pathname) || url.search || url.hash) throw new Error('Fotoğraf cihazdan okunamadı.');
  const response = await fetcher(photo.webPath);
  if (!response.ok) throw new Error('Fotoğraf cihazdan okunamadı.');
  const size = Number(response.headers?.get?.('content-length'));
  if (size > MAX_PHOTO_BYTES) throw new Error('Fotoğraf en fazla 25 MB olabilir.');
  const blob = await response.blob();
  if (blob.size > MAX_PHOTO_BYTES || !blob.size) throw new Error('Fotoğraf en fazla 25 MB olabilir.');
  if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(blob.type)) throw new Error('Bu fotoğraf biçimi desteklenmiyor.');
  return new FileClass([blob], 'kelimo-fotograf', { type: blob.type });
}
async function cleanupNativeShares(media, now = Date.now()) {
  let entries;
  try { entries = (await media.filesystem.readdir({ path: SHARE_FOLDER, directory: 'CACHE' })).files; } catch { return; }
  for (const entry of entries) {
    const match = SHARE_FILE.exec(entry.name || '');
    if (!match || entry.type !== 'file' || now - Number(match[1]) < 86400000) continue;
    try { await media.filesystem.deleteFile({ path: `${SHARE_FOLDER}/${entry.name}`, directory: 'CACHE' }); } catch { /* cache maintenance is best effort */ }
  }
}
async function shareNativeResult(blob, media = nativeMedia(), options = {}) {
  if (!media) return false;
  if (!blob || blob.type !== 'image/png' || !blob.size || blob.size > MAX_SHARE_BYTES) throw new Error('Sonuç görseli paylaşılamadı.');
  const now = options.now ?? Date.now();
  await cleanupNativeShares(media, now);
  const bytes = await blob.arrayBuffer();
  let binary = ''; for (const value of new Uint8Array(bytes)) binary += String.fromCharCode(value);
  const random = new Uint8Array(8); (options.crypto || globalThis.crypto).getRandomValues(random);
  const suffix = [...random].map(value => value.toString(16).padStart(2, '0')).join('');
  const path = `${SHARE_FOLDER}/result-${now}-${suffix}.png`;
  const result = await media.filesystem.writeFile({ path, data: btoa(binary), directory: 'CACHE', recursive: true });
  // Keep the file for the receiving app to read; later shares remove only our cache files older than one day.
  const {invitationData}=require('./shareInvitation');
  await media.share.share(Object.assign({}, invitationData(), {title:'Kelimo maç sonucum', files:[result.uri], dialogTitle:'Sonucu paylaş'}));
  return true;
}
module.exports = { nativeMedia, cancelledMedia, pickNativePhoto, shareNativeResult, cleanupNativeShares };
